import Notification from './notification';

export default class NotificationEventArgs {
    Data: Notification

    constructor(data: Notification) {
        this.Data = data;
    }
}